import React,{useEffect, useState, useRef} from 'react'
import {TextInput, Box, Image} from 'grommet'
import CheckMarkIcon from 'pages/components/assets/checkmark.png'

const EditTableCell = ({
  type="number",
  value,
 //data,
  tabIndex,
  onSubmit,
  checkbox,
}) =>{
   const [state,setState] = useState(value)
   const [isEditing, setIsEditing] = useState(false)
   const submittedValueRef = useRef(null)
   
   const handleSubmit = () =>{
        onSubmit(state);
        submittedValueRef.current = state;
        setIsEditing(false);
        // Keep the submitted value displayed
        setState(state);
    }
    
    useEffect(()=>{
      // If server value matches our submitted value, clear the submitted state
      if (submittedValueRef.current !== null && parseFloat(value) === parseFloat(submittedValueRef.current)) {
        submittedValueRef.current = null;
      }
      
      // Don't update if we have a submitted value waiting for server confirmation
      if (submittedValueRef.current !== null) {
        return;
      }
      
      // Only update state if we're not editing
      if (!isEditing) {
        setState(value);
      }
    },[value, isEditing])
    
    const keypressHandler = event => {
        if (event.key === 'Enter' || event.key === 'Tab') {
          handleSubmit()
        }
    };

    const handleFocus = () => {
      setIsEditing(true);
    }

    const handleBlur = () => {
      setIsEditing(false);
    }

    return(
      <Box 
        flex
        direction='row' 
        alignSelf='center'
        gap='medium'
      >
        <TextInput
        style={{
          width: '60px',
          height: '30px',
          border: '0px solid white',
        }}
        type={type}
        value={state}
        onChange={(e)=>setState(e.target.value)}
        tabIndex={tabIndex+1}
        onKeyDown={event => keypressHandler(event)}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
        {checkbox && (value !== +state) && <Image 
          alignSelf='center'
          height="16px"
          width="16px"
          src={CheckMarkIcon}
          onClick={() => handleSubmit()}
          style={{cursor: 'pointer'}}
          onMouseDown={e => e.preventDefault()}
          title='Submit Balance'
        />}
      </Box>
    )
}

export default EditTableCell